export default __webpack_public_path__ + "static/media/photo--lg--21.75e2360b.jpg";